export type NetworkData = unknown
export type MapFilters = unknown
export type MapRenderer = (networkData: NetworkData, filters: MapFilters) => void

/**
 * The one seam a command needs into the map. Commands run outside Vue and must
 * not import Leaflet; MapView registers its renderer here and a command asks
 * for a redraw by name. Sub-plan 1F swaps the registration for a React hook
 * without touching a single command.
 *
 * Nothing registered is the normal case — in tests, and in React before 1F —
 * so requesting a render then is a no-op rather than an error.
 */
let renderer: MapRenderer | null = null

/** Register the renderer; returns the function that unregisters it. */
export function registerMapRenderer(fn: MapRenderer): () => void {
  renderer = fn
  // Only clear if this registration is still the current one: a component that
  // unmounts after a newer map mounted must not silence the newer one.
  return () => {
    if (renderer === fn) renderer = null
  }
}

/** Ask the map to redraw. Harmless with no map mounted; a throwing renderer never fails the command. */
export function requestMapRender(networkData: NetworkData, filters: MapFilters): void {
  if (!renderer) return
  try {
    renderer(networkData, filters)
  } catch (error) {
    console.error('[commands] the map renderer threw; the command continues', error)
  }
}

export function __resetMapBridge() {
  renderer = null
}
